/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
/**
 * This file Copyright (c) 2010-2021 Magnolia International
 * Ltd.  (http://www.magnolia-cms.com). All rights reserved.
 *
 *
 * This program and the accompanying materials are made
 * available under the terms of the Magnolia Network Agreement
 * which accompanies this distribution, and is available at
 * http://www.magnolia-cms.com/mna.html
 *
 * Any modifications to this file must keep this entire header
 * intact.
 *
 */
// Auto generated file, don't change manually

import type {
  Asset,
  Rendition
} from '../../../../magnolia/lib/MagnoliaAsset';
import {
  transformNode,
  transformResults
} from '../../../../magnolia/lib/MagnoliaPropertyHelper';

export interface switchableStruct {
  field: string;
  page: any;
  intLinkParam ? : string;
  external: string;
  download: Asset;
}
export interface imageLinkStruct {
  switchable ? : switchableStruct;
  linkTargetMode ? : string;
  title ? : string;
}
export interface switchableModeStruct {
  field: string;
  backgroundColor ? : number;
  image ? : Asset;
  imageTitle ? : string;
  imageLink ? : Array < imageLinkStruct > ;
}
export interface switchableStruct {
  field: string;
  page: any;
  intLinkParam ? : string;
  external: string;
  download: Asset;
}
export interface ctasStruct {
  switchable ? : switchableStruct;
  linkTargetMode ? : string;
  title ? : string;
  titleColor ? : number;
  buttonColor ? : number;
  borderColor ? : number;
}
export default interface CardContent {
  legalTitle ? : string;
  legalText ? : string;
  enableLegalDisclaimer ? : boolean;
  titleOrSubtitle ? : string;
  title ? : string;
  titleColor ? : number;
  headline ? : string;
  headlineColor ? : number;
  subHeadline ? : string;
  subHeadlineColor ? : number;
  switchableMode ? : switchableModeStruct;
  ctas ? : Array < ctasStruct > ;
  imageLoadType ? : string;
  dataABId ? : string;
  metadata ? : any;
}

export const Props = {
  legalTitle: String,
  legalText: String,
  enableLegalDisclaimer: Boolean,
  titleOrSubtitle: String,
  title: String,
  titleColor: Number,
  headline: String,
  headlineColor: Number,
  subHeadline: String,
  subHeadlineColor: Number,
  switchableMode: Object as() => switchableModeStruct,
  ctas: Array as() => Array < ctasStruct > ,
  imageLoadType: String,
  dataABId: String,
  metadata: Object,
}

export const WrapperProps = {
  legalTitle: String,
  legalText: String,
  enableLegalDisclaimer: Boolean,
  titleOrSubtitle: String,
  title: String,
  titleColor: Number,
  headline: String,
  headlineColor: Number,
  subHeadline: String,
  subHeadlineColor: Number,
  switchableMode: Object as() => switchableModeStruct,
  ctas: Object,
  imageLoadType: String,
  dataABId: String,
  metadata: Object,
}

export class CardContentBuilder {
  static build(props: any) {
    props = transformNode(JSON.parse(JSON.stringify(props)));
    class CardContentInstance implements CardContent {
      legalTitle ? : string;
      legalText ? : string;
      enableLegalDisclaimer ? : boolean;
      titleOrSubtitle ? : string;
      title ? : string;
      titleColor ? : number;
      headline ? : string;
      headlineColor ? : number;
      subHeadline ? : string;
      subHeadlineColor ? : number;
      switchableMode ? : switchableModeStruct;
      ctas ? : Array < ctasStruct > ;
      imageLoadType ? : string;
      dataABId ? : string;
      metadata ? : any;

      constructor(props: any) {
        Object.assign(this, props);

        if (this.switchableMode) {
          if (typeof this.switchableMode.image === 'object') {
            this.switchableMode.image = {
              ...this.switchableMode.image,
              link: this.switchableMode.image['@link'],
              name: this.switchableMode.image['@name'],
              path: this.switchableMode.image['@path'],
            };
          } else {
            this.switchableMode.image = null as any;
          }
        }
        if (this.switchableMode) {
          if (this.switchableMode.imageLink) {
            this.switchableMode.imageLink = Object.entries(this.switchableMode.imageLink)
              .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'imageLink' + '[0123456789]+')))
              .map((pair: [string, any]) => ({
                ...pair[1]
              }));
            for (let i1 = 0; i1 < this.switchableMode.imageLink.length; i1++) {

              if (this.switchableMode) {
                if (this.switchableMode.imageLink[i1]) {
                  if (this.switchableMode.imageLink[i1].switchable) {
                    if (typeof this.switchableMode.imageLink[i1].switchable.download === 'object') {
                      this.switchableMode.imageLink[i1].switchable.download = {
                        ...this.switchableMode.imageLink[i1].switchable.download,
                        link: this.switchableMode.imageLink[i1].switchable.download['@link'],
                        name: this.switchableMode.imageLink[i1].switchable.download['@name'],
                        path: this.switchableMode.imageLink[i1].switchable.download['@path'],
                      };
                    } else {
                      this.switchableMode.imageLink[i1].switchable.download = null as any;
                    }
                  }
                }
              }
            }
          } else {
            this.switchableMode.imageLink = null as any;
          }
        }
        if (this.ctas) {
          this.ctas = Object.entries(this.ctas)
            .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'ctas' + '[0123456789]+')))
            .map((pair: [string, any]) => ({
              ...pair[1]
            }));
          for (let i1 = 0; i1 < this.ctas.length; i1++) {

            if (this.ctas[i1]) {
              if (this.ctas[i1].switchable) {
                if (typeof this.ctas[i1].switchable.download === 'object') {
                  this.ctas[i1].switchable.download = {
                    ...this.ctas[i1].switchable.download,
                    link: this.ctas[i1].switchable.download['@link'],
                    name: this.ctas[i1].switchable.download['@name'],
                    path: this.ctas[i1].switchable.download['@path'],
                  };
                } else {
                  this.ctas[i1].switchable.download = null as any;
                }
              }
            }
          }
        } else {
          this.ctas = null as any;
        }
      }
    }
    return new CardContentInstance(props);
  }
}
